import React from 'react'
import { connect } from 'react-redux'
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Tab
} from '@mui/material'
import { TabContext, TabList } from '@mui/lab'
import { formUpdate } from '../lib/form'
import { rxOpenSetting } from '../lib/rx_subject'
import { saveSetting } from '../redux/actions/setting'
import FadeTabPanel from '../components/FadeTabPanel'
import FormWithButton from '../components/FormWithButton'
import Display from './Display'
import Bind from './Bind'
import Sound from './Sound'
import './Setting.scss'

const Setting = ({ user, setting, saveSetting }) => {
  const [open, setOpen] = React.useState(false)
  const [tab, setTab] = React.useState('display')

  const formEls = {
    display: React.createRef(),
    bind: React.createRef(),
    sound: React.createRef()
  }

  const [form, setForm] = React.useState(setting.personal)

  React.useEffect(() => {
    const subscription = rxOpenSetting.subscribe(() => {
      setOpen(true)
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  const onEnter = () => {
    setTab('display')
    setForm(setting.personal)
  }

  const changeTab = (evt, newTab) => {
    if (formEls[tab] && formEls[tab].current && !formEls[tab].current.reportValidity()) {
      return
    }

    setTab(newTab)
  }

  const change = formUpdate(setForm)

  const submit = evt => {
    evt.preventDefault()

    if (formEls[tab] && formEls[tab].current && !formEls[tab].current.reportValidity()) {
      return
    }

    setOpen(false)
    saveSetting({ personal: form })
  }

  const close = () => {
    setOpen(false)
  }

  return (
    <Dialog className="setting-dialog" open={open}
            TransitionProps={{ onEnter }}
            aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">個人設定</DialogTitle>
      <DialogContent className="setting">
        <TabContext value={tab}>
          <TabList onChange={changeTab}>
            <Tab className="setting-tab display-tab" value="display" label="表示" />
            <Tab className="setting-tab bind-tab" value="bind" label="バインド" />
            <Tab className="setting-tab sound-tab" value="sound" label="サウンド" />
          </TabList>
          <FadeTabPanel tab={tab} value="display" className="display-setting">
            <FormWithButton ref={formEls.display} onSubmit={submit}>
              <Display form={form} change={change} />
            </FormWithButton>
          </FadeTabPanel>
          <FadeTabPanel tab={tab} value="bind" className="bind-setting">
            <FormWithButton ref={formEls.bind} onSubmit={submit}>
              <Bind form={form} change={change} />
            </FormWithButton>
          </FadeTabPanel>
          <FadeTabPanel tab={tab} value="sound" className="sound-setting">
            <FormWithButton ref={formEls.sound} onSubmit={submit}>
              <Sound form={form} change={change} />
            </FormWithButton>
          </FadeTabPanel>
        </TabContext>
      </DialogContent>
      <DialogActions className="dialog-actions">
        <form onSubmit={submit}>
          <Button type="submit" className="submit" color="primary">
            設定
          </Button>
          <Button className="close" color="secondary" onClick={close}>
            閉じる
          </Button>
        </form>
      </DialogActions>
    </Dialog>
  )
}

export default connect(
  state => ({
    user: state.user,
    setting: state.setting
  }),
  dispatch => ({
    saveSetting: setting => dispatch(saveSetting(setting))
  })
)(Setting)
